import React from "react";
import { Menu, Sun, Moon } from "lucide-react";
import LanguageSelector from "./LanguageSelector";
import { useTheme } from "../contexts/ThemeContext";

const TopBar = ({ onMenuClick }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header
      className="flex-shrink-0 flex items-center justify-between px-6"
      style={{
        height: "65px",
        backgroundColor: "var(--color-surface)",
        borderBottom: "1px solid var(--color-border)",
        zIndex: 10,
      }}
    >
      {/* Mobile hamburger */}
      <button
        onClick={onMenuClick}
        className="lg:hidden p-2 rounded-lg transition-colors"
        style={{ color: "var(--color-text-muted)" }}
        aria-label="Open menu"
      >
        <Menu size={20} />
      </button>

      {/* Spacer on desktop */}
      <div className="hidden lg:block" />

      {/* Right side */}
      <div className="flex items-center gap-2">
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          className="hover-surface p-2 rounded-lg transition-all"
          style={{
            color: "var(--color-text-muted)",
          }}
          aria-label={theme === "light" ? "Dark mode" : "Light mode"}
          title={theme === "light" ? "Dark mode" : "Light mode"}
        >
          {theme === "light" ? <Moon size={18} /> : <Sun size={18} />}
        </button>

        <LanguageSelector />
      </div>
    </header>
  );
};

export default TopBar;
